module.exports = __webpack_public_path__ + "img/persona.f04e12aa.jpg";